import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';

import { useOpponentsListSelector } from '../hooks/useOpponentsListSelector/useOpponentsListSelector';

interface IMinimizedCallViewPresenter {
  opponentsList: readonly Opponent[];
  call: Call;
  videoOpponent: Opponent;
  hasVideo: boolean;
  showCallPlaceholder: boolean;
  setOpponentsList(opponentsList: readonly Opponent[]): void;
}

export const useMinimizedCallViewPresenter = (): IMinimizedCallViewPresenter => {
  const context = useCallContext();
  const opponentsList = useOpponentsListSelector();

  const presenter = useLocalObservable<IMinimizedCallViewPresenter>(() => ({
    opponentsList: opponentsList,

    get call(): Call {
      return context.call;
    },

    get videoOpponent(): Opponent {
      const opponent = presenter.call.opponents.opponentsWithVideo.find(
        ({ uid }) => uid === presenter.call?.activeOpponentUid
      );
      return (
        opponent ||
        presenter.call.opponents.screenSharingOpponent ||
        presenter.call.opponents.opponentsWithVideo[0] ||
        presenter.opponentsList[0]
      );
    },

    get showCallPlaceholder(): boolean {
      return presenter.call.isCalling;
    },

    get hasVideo(): boolean {
      return !!presenter.videoOpponent?.hasVideo;
    },

    setOpponentsList(opponentsList: readonly Opponent[]): void {
      presenter.opponentsList = opponentsList;
    },
  }));

  useEffect(() => {
    presenter.call.viewState.hideMembers();
  }, []);

  useEffect(() => {
    presenter.setOpponentsList(opponentsList);
  }, [opponentsList]);

  return presenter;
};
